import script from "./blacklist.vue?vue&type=script&setup=true&lang=js"
export * from "./blacklist.vue?vue&type=script&setup=true&lang=js"

import "./blacklist.vue?vue&type=style&index=0&id=54715b03&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54715b03"]])

export default __exports__